import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { isNil, isUndefined } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { concatMap, filter } from 'rxjs/operators';

import { MainTabBasePathEnum } from '../../../../enums/main-tabs';
import { PropertyProfile } from '../../../../store/models/property-profile.model';
import * as fromPropertyProfileSelectors from '../../../../store/selectors/property-profile.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-profile-details',
  standalone: false,
  templateUrl: './details.page.html'
})
export class DetailsPageComponent {
  private store = inject(Store);
  private activatedRoute = inject(ActivatedRoute);

  profileId: string | null;
  profile$: Observable<PropertyProfile>;
  defaultBackHref: string | undefined;

  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'] ?? MainTabBasePathEnum.PropertySearch;
    this.profileId = this.activatedRoute.snapshot.paramMap.get('id');
    this.profile$ = of(this.profileId).pipe(
      filter((id) => !isNil(id)),
      concatMap((id) => this.store.pipe(select(fromPropertyProfileSelectors.selectPropertyProfile(id)))),
      filter((propertyProfile) => !isUndefined(propertyProfile))
    );
  }
}
